import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'removeHtmlAndTruncate',
    standalone: true
})
export class RemoveHtmlAndTruncatePipe implements PipeTransform {

    transform(value: string, maxLength: number): string {
        if (!value) return '';

        const strippedText = value.replace(/<[^>]*>/g, '');

        // Trim whitespace
        const trimmedText = strippedText.trim();

        // Truncate and add ellipsis if necessary
        if (trimmedText.length <= maxLength) {
            return trimmedText;
        }

        return trimmedText.substring(0, maxLength) + '...';
    }

}
